import BaseUseCase from "../../../base_use_case.js.jsx";

class NewInvestmentUseCase extends BaseUseCase {

  execute(identifier, params) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "get",
      url: `/api/v1/admin/projects/investments/new`,
    });
  }
}

const instance = new NewInvestmentUseCase();
export default instance;
